import {i18n, IIndexSignature} from "@selfserve/react-utils";

export const checklistTypesTexts: IIndexSignature<string> = {
  checklist: i18n.t('common.checklist'),
  tourGuide: i18n.t('common.tour_guide'),
  announcement: i18n.t('common.announcement'),
};
